module.exports = __webpack_public_path__ + "img/gamma-slide-right.71d56a51.svg";